import React from 'react';

const RefreshIcon = () => (
  <svg width="45" height="45" viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.6448 20 16.9898
      18.7166 18.4463 16.7386L16.7532 15.6621C15.656 17.0841 13.935 18 12 18C8.68629
      18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C13.1889 6 14.297 6.3458 15.2293 6.9423L13.8284
      8.34315L18.7782 9.05025L18.0711 4.10051L16.6683 5.50258C15.3545 4.55697 13.7423 4 12 4Z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
);

export default RefreshIcon;
